
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/home_page",
      function () {
        return require("private-next-pages/gifts/home_page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/home_page"])
      });
    }
  